import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ColorBrandBlue1, ColorNeutralWhite } from 'autogen/design-tokens/tokens';
import { CustomerServiceButton } from 'autogen/translation-keys/trans-website-chat';
import Icon from 'components/Icon';
import StatusIndicator from 'components/shared/statusIndicator';
import { popup } from 'modules/helpers/animations';
import { zIndex } from 'variables/layers';
import { useChatStore } from '../ChatStore';
import { dialog } from '../chatConstants';
import { AnimatedHeroCTA } from '../heroCTA';

// #region Styles

const Wrapper = styled.div`
    position: fixed;
    height: 80px;
    bottom: 14px;
    right: 14px;
    display: flex;
    align-items: flex-end;
    z-index: ${zIndex.fixed + 1};
`;

const Button = styled.button`
    position: relative;
    height: 62px;
    width: 62px;
    padding: 0;
    background: ${ColorBrandBlue1};
    color: ${dialog.textColor};
    font-weight: bold;
    border: 0;
    border-radius: 50%;
    z-index: ${zIndex.fixed};
    animation: ${popup} 0.5s cubic-bezier(0.215, 0.61, 0.355, 1);

    &:focus {
        outline: none;
    }
`;

const FlexCenter = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    height: 100%;
    line-height: 1.2;
`;

const StyledCloseIcon = styled(Icon)`
    path {
        fill: ${ColorNeutralWhite};
    }
`;

const StyledChatIcon = styled(Icon)`
    path {
        fill: ${ColorNeutralWhite};
    }
`;

// #endregion Styles

interface IChatButtonProps {
    toggleChat: () => void;
    chatOpen: boolean;
}

function ChatButton(props: IChatButtonProps) {
    const { toggleChat, chatOpen } = props;
    const { t } = useTranslation();
    const isChatOnline = useChatStore((state) => state.isOnline);

    return (
        <Wrapper>
            <AnimatedHeroCTA />
            <Button type="button" aria-label={t(CustomerServiceButton)} onClick={toggleChat}>
                {isChatOnline && <StatusIndicator left={45} />}
                <FlexCenter>
                    {chatOpen ? <StyledCloseIcon type="Close" size={24} /> : <StyledChatIcon type="Chat" size={24} />}
                </FlexCenter>
            </Button>
        </Wrapper>
    );
}

export default ChatButton;
